import { ClientResponse } from '../model/ClientResponse';
import PracovnyKrokEnum from '../model/pracovnyKrok/PracovnyKrokEnum';
import { fetchLegislativnyMaterialDetail } from '../client/legislativnyMaterial/legislativnyMaterialDetailClient';
import LegislativnyMaterialDetail from '../model/legislativnyMaterial/LegislativnyMaterialDetail';
import { fetchZodpovednyPredkladatelList } from '../client/external/iam/pouzivatelListClient';

interface ReturnType {
  nazovPozicie: string;
  materialDetail: LegislativnyMaterialDetail,
}

export default async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokEnum: PracovnyKrokEnum,
  options?: { headers?: object },
): Promise<ClientResponse<ReturnType>> => {
  const {
    data: materialDetail,
  } = await fetchLegislativnyMaterialDetail(type, year, index, pracovnyKrokEnum, options);

  const getNazovPozicie = (): string => pouzivatelList?.find(pouzivatel => pouzivatel.uuid
    === materialDetail?.zodpovednyPredkladatel?.uuid)?.nazovPozicie;

  const {
    data: pouzivatelList,
    responseCode,
  } = await fetchZodpovednyPredkladatelList(
    materialDetail?.zodpovednaInstitucia?.ldapUuid,
    null,
    undefined,
    options,
  );

  return {
    data: {
      nazovPozicie: getNazovPozicie(),
      materialDetail,
    },
    responseCode,
  };
};
